var React = require('react');

function IconSuccessSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M511.4 65.2c-247 0-447.2 200.2-447.2 447.2s200.2 447.2 447.2 447.2 447.2-200.2 447.2-447.2S758.4 65.2 511.4 65.2zm-29.3 624.2L294.7 537.9c-1.3-1.1-1.5-3.1-.3-4.4l48.7-53.5c1.1-1.2 2.9-1.3 4.1-.3l129.7 105.1L690 332.3c1.1-1.3 2.9-1.4 4.2-.4l57.9 47.6c1.3 1.1 1.5 3 .4 4.3L486.2 689c-1.1 1.2-2.9 1.4-4.1.4z"}));
}

IconSuccessSolid.displayName = "IconSuccessSolid";

IconSuccessSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconSuccessSolid;

IconSuccessSolid.default = IconSuccessSolid;
